import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { getGoogleWebClientId } from '@/config/runtimeConfig';

const GoogleOAuthProviderWrapper = ({ children }) => {
  const googleClientId = getGoogleWebClientId();
  if (!googleClientId) {
    return children;
  }
  return <GoogleOAuthProvider clientId={googleClientId}>{children}</GoogleOAuthProvider>;
};

export default GoogleOAuthProviderWrapper;
